import React from "react";
import {Helmet} from "react-helmet";
import { useLanguage } from '../includes/LanguageContext.js';
const AboutUs=()=>{
    const { currentLanguage, selectedLanguage, setSelectedLanguage } = useLanguage();
    const bulletStyle = {
  paddingLeft: '2.2rem',
  marginBottom: '1rem',
};

const listItemStyle = {
  marginBottom: '0.5rem',
};
    return(
        <>
        <Helmet>
                <meta charSet="utf-8" />
                <title>About Us Page</title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Helmet application" />
        </Helmet>
        <div className="container-fluid"> 
            <div className="row p-3">
            <div className="col-md-2"></div>
            <div className="col-md-8">
                    <h1>{currentLanguage.aboutUs.title}</h1>
                    <hr className="border border-danger border-2 opacity-50 w-25"/>
                <div className="row">
                    <p className="contentHeading">KahaniFM  :</p>
                    <p>
                    {currentLanguage.aboutUs.intro}
                    </p>
                    <p>
                    {currentLanguage.aboutUs.belief}
                    </p>
                    <h2>
                    {currentLanguage.aboutUs.whatIs.heading}
                    </h2>
                    <ul style={bulletStyle}>
                        {currentLanguage.aboutUs.whatIs.points.map((point, index) => (
                            // <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                            <li
                                key={index}
                                className="mb-2"
                                style={listItemStyle}
                                dangerouslySetInnerHTML={{ __html: point }}
                                />
                        ))}
                    </ul>
                    <p>
                        {currentLanguage.aboutUs.whatIs.desc}
                    </p>
                    <p className="contentHeading">{currentLanguage.aboutUs.slogan}</p>
                    <h2>
                    {currentLanguage.aboutUs.submission.heading}
                    </h2>
                    <p className="contentHeading"> {currentLanguage.aboutUs.submission.subheading}</p>
                    <p>{currentLanguage.aboutUs.submission.desc}</p>
                    <p className="contentHeading"> {currentLanguage.aboutUs.submission.howTo.title}</p>
                    <p>{currentLanguage.aboutUs.submission.howTo.email}</p>
                    <p>
                    {currentLanguage.aboutUs.submission.howTo.subjectLine}
                    </p>
                    <p className="contentHeading">{currentLanguage.aboutUs.submission.howTo.example}</p>
                    <p className="contentHeading">{currentLanguage.aboutUs.submission.howTo.title1}</p>
                    <ul style={bulletStyle}>
                        {currentLanguage.aboutUs.submission.howTo.include.map((point, index) => (
                            <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                        ))}
                    </ul>
                    
                    <p className="contentHeading">{currentLanguage.aboutUs.submission.whatYouGet.title}     </p>
                    <ul style={bulletStyle}>
                        {currentLanguage.aboutUs.submission.whatYouGet.items.map((point, index) => (
                            <li key={index} className="mb-2" style={listItemStyle}>{point}</li>
                        ))}
                    </ul>
                    
                    <p>
                    {currentLanguage.aboutUs.submission.callToAction} 
                    </p>
                    <p>
                    {currentLanguage.aboutUs.submission.sendEmail} 
                    </p>
                    <p>
                    {currentLanguage.aboutUs.submission.note} 
                    </p>
                    <p>
                    {currentLanguage.aboutUs.submission.publishInfo} 
                    </p>

                </div>    

            </div>
            <div className="col-md-2"></div>
            </div>
        </div>
        </>
    )
}

export default AboutUs;